/* eslint-disable */

export enum ChargeType {
	NotSet = 0,
	AdministrationFee = 1,
	Freight = 2,
	Discount = 3,
	Additional = 4,
	
}
